// extracted by mini-css-extract-plugin
export default {"root":"LoginPage-module_root_fb55e5"};